import type { IContractToRegistration } from '@klp/contractregistration/classes';
import type { MUIDataTableOptions } from 'mui-datatables';
import i18n from '@forvalter/i18n/config';

type getTableOptionsProps = {
    handleRowClick: (
        _rowData: Array<string>,
        rowMeta: {
            dataIndex: number;
        },
    ) => void;
    registrationLines: Array<IContractToRegistration>;
    openPopperId: string | null;
};

export const getTableOptions = ({
    handleRowClick,
    registrationLines,
    openPopperId,
}: getTableOptionsProps) => {
    const tableOptions: MUIDataTableOptions = {
        onRowClick: handleRowClick,
        // Searching and filtering is done in the filter panel above the table
        search: false,
        download: false,
        print: false,
        viewColumns: true,
        filter: false,
        sort: true,
        sortOrder: { name: 'signertDato', direction: 'desc' },
        selectableRowsHideCheckboxes: true,
        selectableRowsHeader: false,
        selectableRowsOnClick: false,
        enableNestedDataAccess: '.',
        textLabels: {
            body: {
                noMatch: i18n.t(
                    'checkOffContract.table.noRelevantContractLines',
                ),
                toolTip: i18n.t('tables.body.toolTip'),
                columnHeaderTooltip: (column) =>
                    i18n.t('tables.body.toolTipFor') + column.label,
            },
            pagination: {
                next: i18n.t('tables.pagination.next'),
                previous: i18n.t('tables.pagination.previous'),
                rowsPerPage: i18n.t('tables.pagination.rowsPerPage'),
                displayRows: i18n.t('tables.pagination.displayRows'),
            },
            toolbar: {
                downloadCsv: i18n.t('tables.toolbar.downloadCsv'),
                print: i18n.t('tables.toolbar.print'),
                viewColumns: i18n.t('tables.toolbar.viewColumns'),
            },
            viewColumns: {
                title: i18n.t('tables.viewColumns.title'),
                titleAria: i18n.t('tables.viewColumns.titleAria'),
            },
            selectedRows: {
                text: i18n.t('tables.selectedRows.text'),
                delete: i18n.t('tables.selectedRows.delete'),
                deleteAria: i18n.t('tables.selectedRows.deleteAria'),
            },
        },
        setRowProps: (row, dataIndex) => {
            const dokumentId = registrationLines[dataIndex].dokumentId;
            return {
                'data-active': openPopperId === dokumentId ? 'true' : 'false',
            };
        },
    };

    return tableOptions;
};
